(function() {
    'use strict';
    angular.module('app')
        .controller('OnboardingController', function($scope, $location) {});
})();


// WEBPACK FOOTER //
// ./js/controllers/OnboardingController.js